import {
	sourcetypeByID,
	sourcetypeCreate,
	sourcetypeDestroy,
	sourcetypesList,
	sourcetypeUpdate,
} from '@/services/jobs/salarySource.service'

export default {
	namespaced: true,
	state: {
		// SOURCETYPES
		sourcetypesList: {},
		sourcetype: {},
		// STATUS SOURCETYPE
		sourcetypesStatus: 'pending',
		sourcetypesSaveStatus: 'init',
		sourcetypesDeleteStatus: 'init',
	},
	getters: {
		// SOURCETYPE
		getSourcetypesList(state) {
			return state.sourcetypesList
		},
		getSourcetype(state) {
			return state.sourcetype
		},
		// SOURCETYPE
		getSourcetypesDeleteStatus(state) {
			return state.sourcetypesDeleteStatus
		},
		getSourcetypesSaveStatus(state) {
			return state.sourcetypesSaveStatus
		},
		getSourcetypesStatus(state) {
			return state.sourcetypesStatus
		},
	},
	mutations: {
		// SOURCETYPES
		SOURCETYPES_LIST(state, value) {
			state.sourcetypesList = value
		},
		SET_SOURCETYPE(state, value) {
			state.sourcetype = value
		},
		// STATUS SOURCETYPES
		SOURCETYPES_STATUS(state, value) {
			state.sourcetypesStatus = value
		},
		SOURCETYPE_SAVE_STATUS(state, value) {
			state.sourcetypesSaveStatus = value
		},
		SOURCETYPE_DELETE_STATUS(state, value) {
			state.sourcetypesDeleteStatus = value
		},
	},
	actions: {
		// Sourcetypes
		async fetchSourcetypeList({ commit }, params) {
			console.log('params', params)
			commit('SOURCETYPES_STATUS', 'pending')
			commit('SOURCETYPES_LIST', {})
			try {
				const { data } = await sourcetypesList(params)
				console.log(data)
				commit('SOURCETYPES_STATUS', 'init')
				commit('SOURCETYPES_LIST', data)
				return data
			} catch (error) {
				commit('SOURCETYPES_STATUS', 'init')
				throw error
			}
		},
		async fetchSourcetypeByID({ commit }, params) {
			commit('SOURCETYPES_STATUS', 'pending')
			try {
				const { data } = await sourcetypeByID(params)
				commit('SOURCETYPES_STATUS', 'init')
				commit('SET_SOURCETYPE', data.data)
				return data
			} catch (error) {
				commit('SOURCETYPES_STATUS', 'init')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
		async saveNewSourcetype({ commit }, params) {
			commit('SOURCETYPE_SAVE_STATUS', 'pending')
			try {
				const { data } = await sourcetypeCreate(params)
				commit('SOURCETYPE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SOURCETYPE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateSourcetype({ commit }, params) {
			commit('SOURCETYPE_SAVE_STATUS', 'pending')
			try {
				const { data } = await sourcetypeUpdate(params)
				commit('SOURCETYPE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SOURCETYPE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteSourcetypeByID({ commit }, params) {
			commit('SOURCETYPE_DELETE_STATUS', 'pending')
			try {
				const { data } = await sourcetypeDestroy(params)
				commit('SOURCETYPE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SOURCETYPE_DELETE_STATUS', 'error')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
	},
}
